import ExpensesExplainer from '../../../onboarding/components/ExpensesExplainer';

export default function ExpensesExplainerScreen() {
    return <ExpensesExplainer />;
}
